
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationArchiveHeadline: {
    id: "Archive.headline",
    defaultMessage: "Are you sure you want to archive your configuration?",
  },
  configurationArchiveButton: {
    id: "Archive.button",
    defaultMessage: "Accept",
  }, 
});

export default MESSAGES;